/* eslint-disable react/require-default-props,react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';

import PickInput from './PickInput';
import styles from './index.styl';

const PickList = ({ list, name, selectedItems, onChange }) => {
  const [values, setValue] = useState(null);

  useEffect(() => {
    setValue(selectedItems);
  }, []);

  useEffect(() => {
    if (onChange) onChange(values);
  }, [values]);

  const handleSelect = (value, isChecked) => {
    const changedValues = values ? [...values] : [];
    if (isChecked) {
      changedValues.push(value);
    } else {
      changedValues.splice(findIndex(values, item => item === value), 1);
    }
    setValue(!isEmpty(changedValues) ? changedValues : null);
  };

  return (
    <div styleName="root">
      {list &&
        list.map((item, index) => (
          <PickInput
            key={`${name}-${index}`}
            id={`${name}-${index}`}
            label={item}
            name={name}
            value={item}
            defaultChecked={selectedItems ? selectedItems.includes(item) : null}
            onClick={e => handleSelect(item, e.target.checked)}
          />
        ))}
    </div>
  );
};

PickList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedItems: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
};

export default CSSModules(PickList, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/PickList/index.jsx